import React, { ReactNode } from 'react';
import { UseZodFormReturn } from '@repo/hooks/useZodForm';
import { Form } from './Form';

export interface MaybeFormProps {
  form?: UseZodFormReturn;
  children?: ReactNode;
}
export function MaybeForm({ form, children }: MaybeFormProps) {
  if (form) {
    return (
      <Form {...form} className="mx-auto">
        {children}
      </Form>
    );
  }
  return <>{children}</>;
}
